import React, { useState } from "react";
import ChatWindow from "./components/ChatWindow";

function App() {
  return (
    <div className="app">
      <ChatWindow />
    </div>
  );
}

export default App;
